import React, { useEffect } from 'react';
import urlMap from '../../components/enigmes/e_sceau.js';
import '../../css/Sceau.css';

function Sceau() {
    useEffect(() => {
        // Change the title of the page
        document.title = 'Sceau';
    }, []);

    const handleButtonClick = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className='sceau'>
            <div className='links'>
                {Object.entries(urlMap).map(([key, url]) => (
                    <button key={key} onClick={() => handleButtonClick(url)}>{key}</button>
                ))}
            </div>
        </div>
    );
}

export default Sceau;
